module.exports = __webpack_public_path__ + "static/img/10.186f0fc.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/culture/10.png
// module id = UsDi
// module chunks = 1